import React from 'react'
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import SubmitOrCancel from 'live/components/forms/ui/submit-or-cancel'
import { requestCommon } from 'live/lib/utils'
import PeriodPicker from './PeriodPicker'
import MarkerCurves from './CurvesList'
import { MarkersAnnotation } from '../../api'

interface ConfigFormProps {
    event: MarkersAnnotation
    liftSubmitFn?: (fn: () => void) => void
    onHide?: () => void
}

function MarkerFormConfigs({ event, ...props }: ConfigFormProps): JSX.Element {
    const textAreaRef = React.useRef<HTMLTextAreaElement>()
    const [begin, setBegin] = React.useState(event.begin)
    const [saving, setSaving] = React.useState(false)

    const onChangeDate = (value): void => {
        setBegin(value)
    }

    const submit = React.useCallback((): Promise<unknown> => {
        if (isNaN(begin)) return

        setSaving(true)

        const annotation: MarkersAnnotation = {
            ...event,
            begin: begin,
            message: textAreaRef.current.value
        }

        annotation.extra.value = begin

        return fetch('/services/plugin-annotations/annotations/', {
            method: 'POST',
            ...requestCommon,
            body: JSON.stringify(annotation)
        })
            .then(() => {
                if (props.liftSubmitFn && props.onHide) props.onHide()
            })
            .catch(console.error)
            .finally(() => setSaving(false))
    }, [begin])

    React.useEffect(() => {
        if (typeof props.liftSubmitFn === 'function') {
            props.liftSubmitFn(submit)
        }
    }, [submit])

    const errors = isNaN(begin)

    return (
        <StyledForm>
            <div>
                <PeriodPicker
                    isTime={event.extra.target.spanType === 'time'}
                    value={event.begin}
                    onChange={onChangeDate}
                />
                <MarkerCurves widgets={event.extra.widgets} />
                <div className="message">
                    <label>{i18n('Note text')}</label>
                    <textarea defaultValue={event.message} ref={textAreaRef}></textarea>
                </div>
            </div>
            <hr />
            {!props.liftSubmitFn && (
                <div className="footer">
                    <SubmitOrCancel
                        btnsClassName="btn-lg btn-bold"
                        disabled={errors}
                        saving={saving}
                        valid={!errors}
                        onSubmit={submit}
                        onCancel={props.onHide}
                    />
                </div>
            )}
        </StyledForm>
    )
}

// MarkerAnnotationFormConfigs
export default {
    get shortTitle(): string {
        return i18n('MARKERS')
    },
    get title(): string {
        return i18n('CREATE MARKER')
    },
    get editTitle(): string {
        return i18n('EDIT MARKER')
    },
    component: MarkerFormConfigs
}

const StyledForm = styled.div`
    & > div {
        padding: 10px 15px;
    }
    hr {
        margin: 0px;
    }
    .period-picker-time {
        margin-top: 10px;
        .react-datepicker-wrapper {
            i {
                color: #37a3ef !important;
            }
            .react-datepicker__input-container > div {
                width: 190px;
            }
        }
        .date,
        .time {
            label {
                text-align: left;
            }
        }
    }

    .widgets {
        margin-top: 15px;
    }

    .message {
        margin-top: 10px;
        label {
            text-align: left;
        }
    }

    .footer {
        display: flex;
    }
`
